import React from 'react';
import { LoadingSpinner } from './LoadingSpinner';

interface LoadingOverlayProps {
  isLoading: boolean;
  message?: string;
  fullScreen?: boolean;
  blur?: boolean;
  children?: React.ReactNode;
}

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  isLoading,
  message = 'Loading...',
  fullScreen = false,
  blur = true,
  children
}) => {
  if (!isLoading && !children) return null;

  return (
    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
      {children}
      {isLoading && (
        <div
          style={{
            position: fullScreen ? 'fixed' : 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 'var(--space-3)',
            background: blur 
              ? 'rgba(255, 255, 255, 0.9)' 
              : 'var(--color-surface)',
            backdropFilter: blur ? 'blur(4px)' : 'none',
            zIndex: fullScreen ? 9999 : 10,
            transition: 'opacity var(--transition-fast)',
          }}
        >
          <LoadingSpinner size="large" />
          {message && (
            <p style={{
              fontSize: 'var(--text-base)',
              color: 'var(--color-text-secondary)',
              fontWeight: 'var(--font-medium)'
            }}>
              {message}
            </p>
          )}
        </div>
      )}
    </div>
  );
};